import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { HtmlBase, PropertyData, MainblockModel, BlockItem, BlockFile, BlockTree, BObjectModel, eAppContext, FileModel } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { HttpService, CoreService, FilesManagerService } from '../../../../services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../toast';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-accessDocAndFile',
  templateUrl: './access-doc-and-file.component.html',
  styleUrls: ['./access-doc-and-file.component.css', '../../dynamictag.component.css']
})
export class AccessDocAndFileComponent extends BaseAddOnComponent implements OnInit {
  public GED: BlockItem = new BlockItem();
  public oldFile: BlockFile | null = null;
  public insertDocModel: BObjectModel;
  // tslint:disable-next-line:no-input-rename
  @Input('model') model: BObjectModel;
  @Input('input') input: PropertyData;
  @Output() inputChange: EventEmitter<PropertyData> = new EventEmitter<PropertyData>(false);
  @Output() setInput: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(true);

  @ViewChild('closeModal') closeModal: ElementRef<HTMLButtonElement>;
  constructor(
    private http: HttpService,
    private modalService: NgbModal,
    private indParam: CoreService,
    private toast: ToastService,
    private cd: ChangeDetectorRef,
    public fileService: FilesManagerService,
  ) { super(); }


  ngOnInit(): void {
    if (this.indParam.Context === eAppContext.QUEOVAL && this.input.MainElementList.length > 2 && this.input.MainElementList[2].TypeModal === 'DOCUWEB') {
      this.http.getHttp<MainblockModel>(`${this.indParam.AppParams.apiUrl}api/mainblocks/getData/GET_EXPLORER_FILES/0`).subscribe(
        (result: MainblockModel) => {
          this.GED = result.BlockData;
        });
    }
  }

  public OpenGED(content: any) {
    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-accessDocAndFile-GED qmodalover' }).result.then((result) => {
      switch (result) {
        //  case 'SAVE': this.saveConfigSignature(); break;
        //  case 'CANCEL': this.closeConfigSignature(); break;
      }
    });
  }
  public openUploadDocument(content: any) {
    let values: string[] = this.input.MainElementList[3].Value.split('|');
    if (values.length !== 2) {
      this.toast.showAlertToast(`une erreur inconnue empêche l'ajout d'un nouveau document`);
      return;
    }
    this.insertDocModel = new BObjectModel();
    this.insertDocModel.IdDonneeFils = values[1];
    this.insertDocModel.IdRelation = values[0];

    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'qmodalover' }).result.then((result) => {
      switch (result) {
        //  case 'SAVE': this.saveConfigSignature(); break;
        //  case 'CANCEL': this.closeConfigSignature(); break;
      }
    });
  }

  public closeModalUpload(success: boolean, modalUploadDocument: any) {
    if (success) {
      this.model.Mode = 'GET_SIMPLE_PROPERTY';
      this.model.codeProp = this.input.CodeIdentUnique;
      this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, this.model).subscribe((data: BObjectModel) => {
        if (data && data.Body && data.Body.SelectedGroupsList && data.Body.SelectedGroupsList.length > 0 && data.Body.SelectedGroupsList[0] && data.Body.SelectedGroupsList[0].DataList && data.Body.SelectedGroupsList[0].DataList.length > 0 && data.Body.SelectedGroupsList[0].DataList[0])
          this.input = data.Body.SelectedGroupsList[0].DataList[0];
        this.inputChange.emit(this.input);
        this.cd.detectChanges();
        modalUploadDocument.close();
      });


    }
  }

  public AffectValue(files: Array<BlockFile>, modalUploadDocument: any): void {
    if (files && files.length > 0) {
      this.input.MainElementList[0].Value = files[0].value;
      this.input.MainElementList[0].ToolTip = files[0].key;
      this.inputChange.emit(this.input);

    }
    modalUploadDocument.close();
  }
  public OnClear(): void {
    this.input.MainElementList[0].Value = '';
    this.input.MainElementList[0].ToolTip = '';
    this.inputChange.emit(this.input);
  }

  /**
 * Méthode de téléchargment des fichiers déjà générés
 * @param {FileGenerated} file fichier concerné
 */
  public DownLoadFile(htmlBase: HtmlBase): void {
    if (htmlBase.OnClick.toUpperCase() === 'OPENFILE' || htmlBase.OnClick.toUpperCase() === 'DOCXGENERE') {
      this.indParam.showSplash(true);
      const fileModel: FileModel = new FileModel();
      fileModel.DownloadMode = htmlBase.OnClick;
      fileModel.Ident = this.input.MainElementList[0].MoreValues.Ident;
      fileModel.Extension = htmlBase.MoreValues.Extension;
      fileModel.Name = this.input.MainElementList[0].MoreValues.Ident;
      this.fileService.downloadFile(fileModel);
    } else {
      window.open(htmlBase.OnClick, '_blank')
    }
  }

  navig(button: HtmlBase): void {
      this.setInput.emit(button);
  }
}
